<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M3 8l4.5 3L12 4l4.5 7L21 8l-2 11H5L3 8z" />
  </svg>
</template>

<script>
export default {
  name: 'IconCrown',
  props: { size: { type: [String, Number], default: 16 } },
};
</script>
